import React from 'react';
import { useNavigate } from 'react-router-dom';
import KBLogo from './KBLogo';

const PolicyLayout = ({ title, children }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-charcoal min-h-screen text-zinc-300 font-sans selection:bg-emerald-accent/30">
      <header className="p-6 flex justify-between items-center max-w-6xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-zinc-500 hover:text-emerald-accent transition-colors">
          ← Back
        </button>
        <KBLogo size={40} />
      </header>
      
      <main className="max-w-4xl mx-auto px-6 py-12 md:py-20">
        <h1 className="text-4xl md:text-5xl font-black text-white mb-10 border-b border-emerald-accent/20 pb-6">
          {title}
        </h1>
        <div className="space-y-6 text-lg leading-relaxed text-zinc-400">
          {children}
        </div>
      </main>
      
      <footer className="py-10 text-center text-zinc-600 text-sm">
        © {new Date().getFullYear()} Kshitiz Bisht Fitness
      </footer>
    </div>
  );
};

export default PolicyLayout;
